import { render } from "./apk.vue?vue&type=template&id=66e1c926&ts=true"
import script from "./apk.vue?vue&type=script&lang=ts"
export * from "./apk.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__